import {CaseActions} from "../redux_constants/cases.constant";

const InitialState = {
    numPages: 1, 
    pageNumber: 1,
    total: 1,
    case_status: {},
    case_priority: [],
    case_ids: [],
    users: {},
    metsSelectedSlide: "", //ID of selected slide for mets
}

export const caseStatusReducer = (state = InitialState, action) => {
  switch (action.type) {
    case CaseActions.CHANGE_PAGE_CASE:
        return {
            ...state, 
            pageNumber: action.pageNumber
        }
    case CaseActions.CHANGE_TOTAL_NUMBER_OF_PAGES_CASE:
        return {
            ...state, 
            numPages: action.numPages
        }
    case CaseActions.UPDATE_CASE_STATUS:
        var updatedInfo = {}
        for (var i = 0; i < action.status.length; i++){
            let status = action.status[i]
            updatedInfo[status.id] = status;
        }
        return {
            ...state,
            case_status: updatedInfo
        }
      case CaseActions.UPDATE_CASE_PRIORITY:
          const priorities = action.priorities
          let case_priorities = []
          for (let i = 0; i < priorities.length; i++) {
              case_priorities.push({id: priorities[i].id, name: priorities[i].name})
          }
          return {
              ...state,
              case_priority: case_priorities
          }
      case CaseActions.UPDATE_CASE_IDS:
          return {
              ...state,
              case_ids: action.case_ids
        }
    case CaseActions.UPDATE_USERS:
        var updatedInfo = {}
        for (var i = 0; i < action.users.length; i++){
            let user = action.users[i]
            updatedInfo[user.id] = user;
        }
        return {
            ...state, 
            users: updatedInfo
        }
    case CaseActions.CHANGE_TOTAL_CASE:
        return {
            ...state, 
            total: action.total
        }
      case CaseActions.METS_SELECT_SLIDE:
          return {
              ...state,
              metsSelectedSlide: action.selectedSlide
          }
    default:
      return state;
  }
};
